import { render } from "./GhChart.vue?vue&type=template&id=a6527e2c&scoped=true"
import script from "./GhChart.vue?vue&type=script&lang=js"
export * from "./GhChart.vue?vue&type=script&lang=js"

import "./GhChart.vue?vue&type=style&index=0&id=a6527e2c&lang=less&scoped=true"

import exportComponent from "E:\\MyProject\\crash-webfrontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6527e2c"]])

export default __exports__